/* FragranceADDX Theme JavaScript */

// ============================================
// PRODUCT CARD VARIANT SELECTOR
// ============================================
class ProductCardVariants {
  constructor(card) {
    this.card = card;
    this.sizeBtns = card.querySelectorAll('[data-variant-id]');
    this.priceEl = card.querySelector('[data-card-price]');
    this.comparePriceEl = card.querySelector('[data-card-compare-price]');
    this.variantInput = card.querySelector('[data-card-variant-input]');
    this.atcBtn = card.querySelector('.product-card__atc-btn');
    this.init();
  }

  init() {
    this.sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => this.select(btn));
    });
  }

  select(btn) {
    // Update active state
    this.sizeBtns.forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    const price = parseInt(btn.dataset.price, 10);
    const comparePrice = parseInt(btn.dataset.comparePrice, 10);
    const available = btn.dataset.available === 'true';
    const variantId = btn.dataset.variantId;

    // Update price display
    if (this.priceEl) {
      this.priceEl.textContent = this.formatMoney(price);
    }

    // Update compare price
    if (this.comparePriceEl) {
      if (comparePrice > price) {
        this.comparePriceEl.textContent = this.formatMoney(comparePrice);
        this.comparePriceEl.style.display = '';
      } else {
        this.comparePriceEl.style.display = 'none';
      }
    }

    // Update hidden variant input
    if (this.variantInput) {
      this.variantInput.value = variantId;
    }

    // Sync express checkout variant + availability
    const payInput = this.card.querySelector('[data-card-pay-variant-input]');
    if (payInput) payInput.value = variantId;
    const expressForm = this.card.querySelector('.product-card__express-checkout');
    if (expressForm) expressForm.style.display = available ? '' : 'none';

    // Update ATC button state
    if (this.atcBtn) {
      if (available) {
        this.atcBtn.disabled = false;
        this.atcBtn.textContent = 'Add to Cart';
      } else {
        this.atcBtn.disabled = true;
        this.atcBtn.textContent = 'Sold Out';
      }
    }
  }

  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}


// ============================================
// CART DRAWER
// ============================================
class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.overlay = document.getElementById('CartDrawerOverlay');
    this.init();
  }

  init() {
    if (!this.drawer) return;
    document.querySelectorAll('[data-cart-drawer-open]').forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); this.open(); });
    });
    document.querySelectorAll('[data-cart-drawer-close]').forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  }

  open() {
    this.drawer.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-is-open');
    this._smileToggle(false);
    if (window.cartInstance) window.cartInstance.refreshCartDrawer();
  }

  close() {
    this.drawer.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('cart-is-open');
    this._smileToggle(true);
  }

  _smileToggle(show) {
    const el =
      document.querySelector('[id^="smile-"]') ||
      document.querySelector('smile-ui-container') ||
      document.querySelector('smile-launcher') ||
      document.querySelector('[class*="smile-launcher"]') ||
      document.querySelector('[class*="smile-ui"]');
    if (el) el.style.setProperty('display', show ? '' : 'none', 'important');
  }
}

// ============================================
// MOBILE MENU
// ============================================
class MobileMenu {
  constructor() {
    this.menu = document.getElementById('MobileMenu');
    this.overlay = document.getElementById('MobileMenuOverlay');
    this.init();
  }

  init() {
    if (!this.menu) return;
    const openBtn = document.getElementById('MobileMenuOpen');
    const closeBtn = document.getElementById('MobileMenuClose');

    if (openBtn) openBtn.addEventListener('click', () => this.open());
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });

    document.querySelectorAll('.mobile-menu__toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const sub = toggle.nextElementSibling;
        if (sub) sub.classList.toggle('is-open');
      });
    });
  }

  open() {
    this.menu.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.menu.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

// ============================================
// HEADER SEARCH
// ============================================
class HeaderSearch {
  constructor() {
    this.form = document.getElementById('HeaderSearchForm');
    this.initDesktop();
    this.initMobile();
  }

  initDesktop() {
    if (!this.form) return;
    const input = this.form.querySelector('.header__search-input');
    if (!input) return;
    input.addEventListener('focus', () => input.classList.add('is-focused'));
    input.addEventListener('blur', () => input.classList.remove('is-focused'));
  }

  initMobile() {
    const toggle = document.getElementById('MobileSearchToggle');
    const bar = document.getElementById('MobileSearchBar');
    const closeBtn = document.getElementById('MobileSearchClose');
    const input = document.getElementById('MobileSearchInput');
    if (!toggle || !bar) return;

    toggle.addEventListener('click', () => {
      const isOpen = bar.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      bar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (isOpen && input) input.focus();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        bar.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        bar.setAttribute('aria-hidden', 'true');
      });
    }

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && bar.classList.contains('is-open')) {
        bar.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        bar.setAttribute('aria-hidden', 'true');
        toggle.focus();
      }
    });
  }
}

// ============================================
// PRODUCT TABS
// ============================================
// ============================================
// STICKY ATC BAR (MOBILE)
// ============================================
class StickyAtc {
  constructor() {
    this.bar = document.getElementById('StickyAtc');
    this.nativeBtn = document.querySelector('[data-atc-btn]');
    this.stickyBtn = document.getElementById('StickyAtcBtn');
    if (!this.bar || !this.nativeBtn) return;
    this.init();
  }

  init() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting;
        this.bar.classList.toggle('is-visible', show);
        this.bar.setAttribute('aria-hidden', String(!show));
      },
      { threshold: 0 }
    );
    observer.observe(this.nativeBtn);

    if (this.stickyBtn) {
      this.stickyBtn.addEventListener('click', () => {
        if (this.stickyBtn.dataset.bisMode) {
          const bisArea = document.getElementById('BisNotify');
          if (bisArea) bisArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          this.nativeBtn.click();
        }
      });
    }
  }
}

class ProductTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.product-tab');
    this.panels = container.querySelectorAll('.product-tab-panel');
    this.heading = container.closest('.product-grid-section')?.querySelector('[data-section-heading]');
    this.defaultIndex = parseInt(container.dataset.defaultTab, 10) || 0;
    this.init();
  }

  init() {
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.activate(i));
    });
    if (this.tabs.length) this.activate(this.defaultIndex);
  }

  activate(index) {
    this.tabs.forEach((t, i) => {
      t.classList.toggle('is-active', i === index);
    });
    this.panels.forEach((p, i) => {
      p.classList.toggle('is-active', i === index);
    });
    if (this.heading && this.tabs[index]) {
      this.heading.textContent = this.tabs[index].dataset.tabTitle || this.tabs[index].textContent.trim();
    }
  }
}

// ============================================
// PRODUCT GALLERY
// ============================================
class ProductGallery {
  constructor() {
    this.mainImage = document.querySelector('.product-gallery__main-img');
    this.thumbs = document.querySelectorAll('.product-gallery__thumb');
    this.init();
  }

  init() {
    if (!this.mainImage || !this.thumbs.length) return;
    this.thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => this.activate(thumb, i));
    });
    if (this.thumbs.length) this.activate(this.thumbs[0], 0);
  }

  activate(thumb, index) {
    this.thumbs.forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    const imgSrc = thumb.querySelector('img')?.src;
    if (imgSrc && this.mainImage) this.mainImage.src = imgSrc;
  }
}

// ============================================
// VARIANT SELECTOR (product page)
// ============================================
class VariantSelector {
  constructor(form) {
    this.form = form;

    // Load variant data from the JSON script tag
    const jsonEl = document.getElementById('ProductVariantsJson');
    try {
      this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (e) {
      console.error('[VariantSelector] Failed to parse variant JSON:', e);
      this.variants = [];
    }

    // Track selected options — one per option group
    this.selectedOptions = {};
    form.querySelectorAll('[data-option-index]').forEach(btn => {
      const idx = btn.dataset.optionIndex;
      if (btn.classList.contains('is-active')) {
        this.selectedOptions[idx] = btn.dataset.optionValue;
      }
    });

    this.priceEl = document.querySelector('[data-product-price]');
    this.comparePriceEl = document.querySelector('[data-product-compare-price]');
    this.stockEl = document.querySelector('[data-product-stock]');
    this.variantInput = form.querySelector('[data-variant-id-input]');
    this.atcBtn = form.querySelector('[data-atc-btn]');

    this.init();
  }

  init() {
    this.form.querySelectorAll('.variant-option-btn').forEach(btn => {
      btn.addEventListener('click', () => this.select(btn));
    });
  }

  select(btn) {
    const idx = btn.dataset.optionIndex;
    const value = btn.dataset.optionValue;

    // Update active state within this option group
    this.form.querySelectorAll(`.variant-option-btn[data-option-index="${idx}"]`).forEach(b => {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    // Update selected label text
    const label = document.querySelector(`[data-selected-option="${idx}"]`);
    if (label) label.textContent = value;

    // Store selection
    this.selectedOptions[idx] = value;

    // Find matching variant
    const variant = this.findVariant();
    if (variant) this.updateUI(variant);
  }

  findVariant() {
    return this.variants.find(v => {
      const keys = Object.keys(this.selectedOptions);
      return keys.every(idx => {
        const val = this.selectedOptions[idx];
        if (idx === '0') return v.option1 === val;
        if (idx === '1') return v.option2 === val;
        if (idx === '2') return v.option3 === val;
        return true;
      });
    });
  }

  updateUI(variant) {
    // Price
    if (this.priceEl) {
      this.priceEl.textContent = this.formatMoney(variant.price);
    }

    // Compare price
    if (this.comparePriceEl) {
      if (variant.compare_at_price > variant.price) {
        this.comparePriceEl.textContent = this.formatMoney(variant.compare_at_price);
        this.comparePriceEl.style.display = '';
      } else {
        this.comparePriceEl.style.display = 'none';
      }
    }

    // Stock message
    if (this.stockEl) {
      if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 30) {
        this.stockEl.textContent = `Only ${variant.inventory_quantity} Left in Stock!`;
        this.stockEl.style.display = '';
      } else {
        this.stockEl.style.display = 'none';
      }
    }

    // Hidden variant ID input
    if (this.variantInput) {
      this.variantInput.value = variant.id;
    }

    // Sync dynamic checkout form variant ID
    const payVariantInput = document.getElementById('PaymentButtonVariantId');
    if (payVariantInput) payVariantInput.value = variant.id;

    // PayPal Pay-in-4 messaging
    const ppEl = document.getElementById('PayPalMessagePDP');
    if (ppEl) {
      ppEl.dataset.ppAmount = (variant.price / 100).toFixed(2);
      renderPayPalMessage('PayPalMessagePDP', 'product');
    }

    // Sticky ATC sync
    const stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = this.formatMoney(variant.price);
    const stickyBtn = document.getElementById('StickyAtcBtn');
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    // ATC button
    if (this.atcBtn) {
      if (variant.available) {
        this.atcBtn.disabled = false;
        this.atcBtn.textContent = 'Add to Cart';
      } else {
        this.atcBtn.disabled = true;
        this.atcBtn.textContent = 'Sold Out';
      }
    }

    // Back-in-stock form toggle
    const bisArea = document.getElementById('BisNotify');
    const atcArea = document.getElementById('AtcArea');
    const stickyBisBtn = document.getElementById('StickyAtcBtn');
    const dcWrapper = document.getElementById('DynamicCheckoutWrapper');
    if (bisArea && atcArea) {
      if (variant.available) {
        atcArea.style.display = '';
        bisArea.style.display = 'none';
        if (dcWrapper) dcWrapper.style.display = '';
        if (stickyBisBtn) { delete stickyBisBtn.dataset.bisMode; stickyBisBtn.textContent = 'Add to Cart'; }
        const bisOosNoteA = document.getElementById('BisOosNote');
        if (bisOosNoteA) bisOosNoteA.style.display = '';
      } else {
        atcArea.style.display = 'none';
        bisArea.style.display = '';
        if (dcWrapper) dcWrapper.style.display = 'none';
        const bisOosNoteB = document.getElementById('BisOosNote');
        if (bisOosNoteB) bisOosNoteB.style.display = 'none';
        bisArea.dataset.variantId = variant.id;
        const bisForm = document.getElementById('BisForm');
        const bisSuccess = document.getElementById('BisSuccess');
        const bisError = document.getElementById('BisError');
        if (bisForm) bisForm.style.display = '';
        if (bisSuccess) bisSuccess.style.display = 'none';
        if (bisError) bisError.style.display = 'none';
        const bisBtn = bisArea.querySelector('.bis-notify__btn');
        if (bisBtn) { bisBtn.disabled = false; bisBtn.textContent = 'Email me when available'; }
        if (stickyBisBtn) { stickyBisBtn.dataset.bisMode = 'true'; stickyBisBtn.textContent = 'Notify Me'; }
      }
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}

// ============================================
// BACK IN STOCK — KLAVIYO ONSITE EMBED API
// ============================================
function initBackInStockForm() {
  const form = document.getElementById('BisForm');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const emailInput = form.querySelector('.bis-notify__email');
    const email = emailInput ? emailInput.value.trim() : '';
    const bisArea = document.getElementById('BisNotify');
    const variantId = bisArea ? bisArea.dataset.variantId : '';
    const submitBtn = form.querySelector('.bis-notify__btn');
    const successMsg = document.getElementById('BisSuccess');
    const errorMsg = document.getElementById('BisError');

    if (!email || !variantId) return;
    if (errorMsg) errorMsg.style.display = 'none';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting...'; }

    try {
      const res = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Vr8wjz', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2024-02-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId
                }
              }
            }
          }
        })
      });

      if (res.ok || res.status === 202) {
        form.style.display = 'none';
        if (successMsg) successMsg.style.display = '';

        const imageUrl = bisArea ? (bisArea.dataset.imageUrl || '') : '';
        const productUrl = bisArea ? (bisArea.dataset.productUrl || '') : '';
        if (imageUrl) {
          const profileProps = { '$email': email, 'bis_product_image': imageUrl, 'bis_product_url': productUrl };
          if (window.klaviyo) {
            window.klaviyo.identify(profileProps);
          } else if (window._learnq) {
            window._learnq.push(['identify', profileProps]);
          }
        }
      } else {
        throw new Error('API ' + res.status);
      }
    } catch (err) {
      console.error('[BIS]', err);
      if (errorMsg) errorMsg.style.display = '';
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Email me when available'; }
    }
  });
}

// ============================================
// QUANTITY BUTTONS
// ============================================
class QuantityInput {
  constructor(container) {
    this.container = container;
    this.input = container.querySelector('[data-qty-input]');
    this.minusBtn = container.querySelector('[data-qty-minus]');
    this.plusBtn = container.querySelector('[data-qty-plus]');
    this.init();
  }

  init() {
    if (!this.input) return;
    if (this.minusBtn) {
      this.minusBtn.addEventListener('click', () => {
        const val = parseInt(this.input.value) || 1;
        if (val > 1) this.input.value = val - 1;
      });
    }
    if (this.plusBtn) {
      this.plusBtn.addEventListener('click', () => {
        const val = parseInt(this.input.value) || 1;
        this.input.value = val + 1;
      });
    }
  }
}

// ============================================
// ADD TO CART
// ============================================
class AddToCart {
  constructor() {
    this.init();
    this.initCartDrawerQtyButtons();
  }

  init() {
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (!btn) return;

        btn.classList.add('btn--loading');
        const originalText = btn.textContent;
        btn.textContent = 'Adding...';

        try {
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });

          if (!response.ok) throw new Error('Add to cart failed');

          btn.textContent = 'Added!';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('btn--loading');
          }, 2000);

          await this.refreshCartDrawer();

          const drawerInstance = window.cartDrawer;
          if (drawerInstance) drawerInstance.open();
        } catch (err) {
          btn.textContent = originalText;
          btn.classList.remove('btn--loading');
          console.error('Add to cart error:', err);
        }
      });
    });
  }

  async refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Update count badges
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Update drawer title
      const titleEl = document.querySelector('.cart-drawer__title');
      if (titleEl) titleEl.textContent = `Your Cart (${cart.item_count})`;

      // Rebuild drawer items
      const itemsEl = document.querySelector('.cart-drawer__items');
      if (itemsEl) {
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p style="text-align:center; padding: 40px 20px; color: #666;">Your cart is empty.</p>';
        } else {
          itemsEl.innerHTML = cart.items.map(item => `
            <div class="cart-item" data-cart-item="${item.key}">
              <img src="${item.image}" alt="${this.escapeHtml(item.title)}" class="cart-item__image" width="80" height="80">
              <div>
                <div class="cart-item__title">${this.escapeHtml(item.product_title)}</div>
                <div class="cart-item__variant">${this.escapeHtml(item.variant_title || '')}</div>
                <div class="cart-item__footer">
                  <div class="cart-item__price">${this.formatMoney(item.final_line_price)}</div>
                  <div class="cart-item__qty">
                    <button class="cart-item__qty-btn" data-change="-1" data-key="${item.key}">−</button>
                    <span class="cart-item__qty-num">${item.quantity}</span>
                    <button class="cart-item__qty-btn" data-change="1" data-key="${item.key}">+</button>
                  </div>
                </div>
                <a href="/cart/change?id=${item.key}&quantity=0" class="cart-item__remove">Remove</a>
              </div>
            </div>
          `).join('') + `<div class="cart-drawer-fbt" id="CartDrawerFbt" style="display:none;"><p class="cart-drawer-fbt__heading">Customers also grab</p><div class="cart-drawer-fbt__grid" id="CartDrawerFbtGrid"></div></div>`;
        }
      }

      // Update footer subtotal / visibility
      const footerEl = document.getElementById('CartDrawerFooter');
      if (footerEl) {
        footerEl.style.display = cart.item_count > 0 ? '' : 'none';
        const subtotalEl = footerEl.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);
      }

      // PayPal Pay-in-4 messaging
      const ppCartEl = document.getElementById('PayPalMessageCartDrawer');
      if (ppCartEl) {
        ppCartEl.dataset.ppAmount = (cart.total_price / 100).toFixed(2);
        if (cart.item_count > 0) {
          renderPayPalMessage('PayPalMessageCartDrawer', 'cart');
        } else {
          ppCartEl.innerHTML = '';
        }
      }

      // Combined dual-milestone progress bar
      this.updateProgressBar(cart);

      // Drawer FBT impulse products
      await this.updateDrawerFbt(cart);

    } catch (e) {
      console.error('Cart refresh error:', e);
    }
  }

  updateProgressBar(cart) {
    const STANDARD = 7500;  // $75 AUD in cents
    const EXPRESS  = 10000; // $100 AUD in cents

    const bar       = document.getElementById('CartProgressBar');
    const fill      = document.getElementById('CartProgressFill');
    const msg       = document.getElementById('CartProgressMsg');
    const milestone = document.getElementById('CartProgressMilestone');

    if (!bar) return;

    if (cart.item_count === 0) {
      bar.style.display = 'none';
      return;
    }

    bar.style.display = '';

    // Fill 0→100% spanning $0→EXPRESS threshold
    const pct = Math.min(100, (cart.total_price / EXPRESS) * 100);
    if (fill) fill.style.width = pct + '%';

    // Milestone tick sits at STANDARD/EXPRESS = 75%
    if (milestone) milestone.style.left = Math.round((STANDARD / EXPRESS) * 100) + '%';

    const remainingStd = Math.max(0, STANDARD - cart.total_price);
    const remainingExp = Math.max(0, EXPRESS  - cart.total_price);

    if (cart.total_price < STANDARD) {
      if (msg) msg.innerHTML = `Add <strong>${this.formatMoney(remainingStd)}</strong> more to unlock FREE standard shipping`;
      bar.classList.remove('cart-progress-bar--std-unlocked', 'cart-progress-bar--exp-unlocked');
    } else if (cart.total_price < EXPRESS) {
      if (msg) msg.innerHTML = `FREE standard shipping unlocked! Add <strong>${this.formatMoney(remainingExp)}</strong> more for free express`;
      bar.classList.add('cart-progress-bar--std-unlocked');
      bar.classList.remove('cart-progress-bar--exp-unlocked');
    } else {
      if (msg) msg.innerHTML = 'FREE express shipping unlocked! Enjoy complimentary delivery.';
      bar.classList.add('cart-progress-bar--std-unlocked', 'cart-progress-bar--exp-unlocked');
    }
  }

  async updateDrawerFbt(cart) {
    const section = document.getElementById('CartDrawerFbt');
    const grid = document.getElementById('CartDrawerFbtGrid');
    if (!section || !grid) return;

    if (cart.item_count === 0) { section.style.display = 'none'; return; }

    const inCartIds = new Set(cart.items.map(i => i.product_id));

    try {
      let products = [];
      try {
        const res = await fetch(`/recommendations/products.json?product_id=${cart.items[0].product_id}&limit=8&intent=related`);
        const data = await res.json();
        products = data.products || [];
      } catch (_) {}

      if (products.length < 2) {
        const colRes = await fetch('/collections/all/products.json?limit=16&sort_by=price-ascending');
        const colData = await colRes.json();
        products = [...products, ...(colData.products || []).filter(p => !inCartIds.has(p.id))];
      }

      const picks = [];
      for (const product of products) {
        if (picks.length >= 3) break;
        if (inCartIds.has(product.id)) continue;
        const variants = (product.variants || []).filter(v => v.available);
        if (!variants.length) continue;
        const twoMl = variants.find(v => /2\s*ml/i.test(v.title || ''));
        const variant = twoMl || variants.sort((a, b) => this.toCents(a.price) - this.toCents(b.price))[0];
        const imgSrc = typeof product.featured_image === 'string'
          ? product.featured_image
          : (product.featured_image?.src || (product.images && product.images[0]?.src) || '');
        picks.push({
          variantId: variant.id,
          productTitle: product.title,
          variantTitle: twoMl && variant.title !== 'Default Title' ? variant.title : null,
          priceCents: this.toCents(variant.price),
          imgSrc: imgSrc ? (imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc) : ''
        });
      }

      if (!picks.length) { section.style.display = 'none'; return; }

      grid.innerHTML = picks.map(p => `
        <div class="cart-drawer-fbt__item">
          ${p.imgSrc ? `<img src="${p.imgSrc}" alt="${this.escapeHtml(p.productTitle)}" class="cart-drawer-fbt__img" width="52" height="52" loading="lazy">` : '<div class="cart-drawer-fbt__img cart-drawer-fbt__img--empty"></div>'}
          <div class="cart-drawer-fbt__info">
            <p class="cart-drawer-fbt__name">${this.escapeHtml(p.productTitle)}</p>
            ${p.variantTitle ? `<p class="cart-drawer-fbt__variant">${this.escapeHtml(p.variantTitle)}</p>` : ''}
            <p class="cart-drawer-fbt__price">${this.formatMoney(p.priceCents)}</p>
          </div>
          <button class="cart-drawer-fbt__btn" data-fbt-variant="${p.variantId}" aria-label="Add to cart">+</button>
        </div>
      `).join('');

      grid.querySelectorAll('[data-fbt-variant]').forEach(btn => {
        btn.addEventListener('click', async () => {
          btn.disabled = true;
          btn.textContent = '✓';
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(btn.dataset.fbtVariant, 10), quantity: 1 })
            });
          } catch (_) {}
          await this.refreshCartDrawer();
        });
      });

      section.style.display = '';
    } catch (err) {
      console.error('Drawer FBT error:', err);
      section.style.display = 'none';
    }
  }

  toCents(price) {
    if (typeof price === 'number') return price;
    return Math.round(parseFloat(price) * 100);
  }

  initCartDrawerQtyButtons() {
    const itemsEl = document.querySelector('.cart-drawer__items');
    if (!itemsEl) return;
    itemsEl.addEventListener('click', async (e) => {
      const btn = e.target.closest('.cart-item__qty-btn');
      if (!btn) return;
      const key = btn.dataset.key;
      const change = parseInt(btn.dataset.change, 10);
      const qtyEl = btn.parentElement.querySelector('.cart-item__qty-num');
      const currentQty = parseInt(qtyEl?.textContent || '1', 10);
      const newQty = Math.max(0, currentQty + change);
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: newQty }),
        });
        await this.refreshCartDrawer();
      } catch (e) {
        console.error('Cart update error:', e);
      }
    });
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
}

// ============================================
// ACCORDION
// ============================================
class Accordion {
  constructor(container) {
    this.items = container.querySelectorAll('.accordion-item');
    this.init();
  }

  init() {
    this.items.forEach(item => {
      const trigger = item.querySelector('.accordion-item__trigger');
      if (trigger) {
        trigger.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');
          this.items.forEach(i => i.classList.remove('is-open'));
          if (!isOpen) item.classList.add('is-open');
        });
      }
    });
  }
}

// ============================================
// FILTER GROUPS
// ============================================
class FilterGroups {
  constructor() {
    this.groups = document.querySelectorAll('.filter-group');
    this.init();
  }

  init() {
    this.groups.forEach(group => {
      const title = group.querySelector('.filter-group__title');
      if (title) {
        title.addEventListener('click', () => {
          const collapsed = group.classList.toggle('is-collapsed');
          title.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });
      }
    });
  }
}

// ============================================
// ANNOUNCEMENT BAR SLIDER
// ============================================
class AnnouncementSlider {
  constructor() {
    this.bar = document.querySelector('.announcement-bar__slider');
    this.items = this.bar ? this.bar.querySelectorAll('.announcement-bar__message') : [];
    this.current = 0;
    this.init();
  }

  init() {
    if (this.items.length <= 1) return;
    this.items.forEach((item, i) => {
      item.style.display = i === 0 ? 'block' : 'none';
    });
    setInterval(() => this.next(), 4000);
  }

  next() {
    this.items[this.current].style.display = 'none';
    this.current = (this.current + 1) % this.items.length;
    this.items[this.current].style.display = 'block';
  }
}

// ============================================
// STICKY HEADER
// ============================================
class StickyHeader {
  constructor() {
    this.header = document.querySelector('.site-header');
    this.init();
  }

  init() {
    if (!this.header) return;
    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 100) {
        if (currentScrollY > lastScrollY) {
          this.header.classList.add('is-hidden');
        } else {
          this.header.classList.remove('is-hidden');
        }
      } else {
        this.header.classList.remove('is-hidden');
      }
      lastScrollY = currentScrollY;
    }, { passive: true });
  }
}

// ============================================
// LAZY IMAGES
// ============================================
function initLazyImages() {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('img[data-src]').forEach(img => observer.observe(img));
  }
}

// ============================================
// FREQUENTLY BOUGHT TOGETHER
// ============================================
class FrequentlyBoughtTogether {
  constructor() {
    this.container = document.getElementById('FbtSection');
    if (!this.container) return;
    this.productId = this.container.dataset.productId;
    this.currentVariantId = parseInt(this.container.dataset.variantId, 10);
    this.currentPrice = parseInt(this.container.dataset.productPrice, 10);
    this.currentTitle = this.container.dataset.productTitle;
    this.currentImg = this.container.dataset.productImg;
    this.picks = [];
    this.init();
  }

  async init() {
    try {
      let products = [];

      const res = await fetch(`/recommendations/products.json?product_id=${this.productId}&limit=8&intent=related`);
      const data = await res.json();
      products = data.products || [];

      if (products.length < 2) {
        const colRes = await fetch('/collections/all/products.json?limit=16&sort_by=price-ascending');
        const colData = await colRes.json();
        products = [...products, ...(colData.products || []).filter(p => p.id !== parseInt(this.productId))];
      }

      for (const product of products) {
        if (this.picks.length >= 2) break;
        if (product.id === parseInt(this.productId)) continue;

        const variants = (product.variants || []).filter(v => v.available);
        if (!variants.length) continue;

        const twoMl = variants.find(v => /2\s*ml/i.test(v.title || ''));
        const variant = twoMl || variants.sort((a, b) => this.toCents(a.price) - this.toCents(b.price))[0];

        const imgSrc = typeof product.featured_image === 'string'
          ? product.featured_image
          : (product.featured_image?.src || (product.images && product.images[0]?.src) || '');

        this.picks.push({
          variantId: variant.id,
          productTitle: product.title,
          variantTitle: twoMl && variant.title !== 'Default Title' ? variant.title : null,
          priceCents: this.toCents(variant.price),
          imgSrc: imgSrc ? (imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc) : ''
        });
      }

      if (!this.picks.length) return;
      this.render();
      this.container.style.display = '';
      this.watchVariantChanges();

    } catch (err) {
      console.error('FBT error:', err);
    }
  }

  render() {
    const allItems = [
      { variantId: this.currentVariantId, productTitle: this.currentTitle, variantTitle: null, priceCents: this.currentPrice, imgSrc: this.currentImg, isCurrent: true },
      ...this.picks.map(p => ({ ...p, isCurrent: false }))
    ];
    const total = allItems.reduce((s, i) => s + i.priceCents, 0);

    this.container.innerHTML = `
      <div class="fbt">
        <h3 class="fbt__heading">Frequently Bought Together</h3>
        <div class="fbt__strip">
          ${allItems.map((item, i) => `
            ${i > 0 ? '<span class="fbt__plus" aria-hidden="true">+</span>' : ''}
            <div class="fbt__strip-item${item.isCurrent ? ' fbt__strip-item--current' : ''}">
              ${item.imgSrc ? `<img src="${this.escapeAttr(item.imgSrc)}" alt="${this.escapeHtml(item.productTitle)}" class="fbt__strip-img" width="80" height="80" loading="lazy">` : '<div class="fbt__strip-img fbt__strip-img--placeholder"></div>'}
            </div>
          `).join('')}
        </div>
        <div class="fbt__list">
          ${allItems.map(item => `
            <label class="fbt__item${item.isCurrent ? ' fbt__item--current' : ''}">
              <input type="checkbox" class="fbt__cb"
                data-variant-id="${item.variantId}"
                data-price="${item.priceCents}"
                ${item.isCurrent ? 'checked disabled' : 'checked'}>
              <div class="fbt__item-body">
                <span class="fbt__item-title">${this.escapeHtml(item.productTitle)}</span>
                ${item.variantTitle ? `<span class="fbt__item-variant">${this.escapeHtml(item.variantTitle)}</span>` : ''}
                ${item.isCurrent ? '<span class="fbt__item-badge">This item</span>' : ''}
              </div>
              <span class="fbt__item-price">${this.formatMoney(item.priceCents)}</span>
            </label>
          `).join('')}
        </div>
        <div class="fbt__footer">
          <p class="fbt__total-wrap">Bundle total: <strong class="fbt__total">${this.formatMoney(total)}</strong></p>
          <button type="button" class="btn btn--primary fbt__btn">Add selected to cart</button>
        </div>
      </div>
    `;

    this.container.querySelectorAll('.fbt__cb:not([disabled])').forEach(cb => {
      cb.addEventListener('change', () => this.updateTotal());
    });

    this.container.querySelector('.fbt__btn')?.addEventListener('click', async () => {
      const items = Array.from(this.container.querySelectorAll('.fbt__cb:checked'))
        .map(cb => ({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 }));
      if (!items.length) return;

      const btn = this.container.querySelector('.fbt__btn');
      const orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        btn.textContent = '✓ Added to cart!';
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
        if (window.cartInstance) await window.cartInstance.refreshCartDrawer();
        if (window.cartDrawer) window.cartDrawer.open();
      } catch (err) {
        console.error('FBT add error:', err);
        btn.textContent = orig;
        btn.disabled = false;
      }
    });
  }

  updateTotal() {
    const total = Array.from(this.container.querySelectorAll('.fbt__cb:checked'))
      .reduce((s, cb) => s + parseInt(cb.dataset.price, 10), 0);
    const el = this.container.querySelector('.fbt__total');
    if (el) el.textContent = this.formatMoney(total);
  }

  watchVariantChanges() {
    document.querySelectorAll('[data-option-value]').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          const priceEl = document.getElementById('ProductPrice');
          if (!priceEl) return;
          const newPrice = Math.round(parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) * 100);
          if (!newPrice) return;
          const cb = this.container?.querySelector('.fbt__cb[disabled]');
          if (cb) {
            cb.dataset.price = newPrice;
            const span = cb.closest('.fbt__item')?.querySelector('.fbt__item-price');
            if (span) span.textContent = this.formatMoney(newPrice);
          }
          this.updateTotal();
        }, 60);
      });
    });
  }

  toCents(price) {
    if (typeof price === 'number') return price;
    return Math.round(parseFloat(price) * 100);
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  escapeAttr(str) {
    return String(str || '').replace(/"/g, '&quot;');
  }
}

// ============================================
// STAR RATINGS — reads data-rating attr set by Liquid, handles rating drop JSON
// ============================================
function initStarRatings() {
  document.querySelectorAll('.js-star-rating').forEach(el => {
    const raw = (el.dataset.rating || '').trim();
    const count = parseInt(el.dataset.count, 10) || 0;
    let rating = parseFloat(raw);
    if (isNaN(rating)) {
      try { rating = parseFloat(JSON.parse(raw).value); } catch(e) { rating = 0; }
    }
    if (!rating || rating <= 0) return;
    const full = Math.min(Math.floor(rating), 5);
    let html = '<span class="star-rating"><span class="star-rating__stars">';
    for (let i = 1; i <= 5; i++) {
      html += `<span class="star ${i <= full ? 'star--full' : 'star--empty'}">★</span>`;
    }
    html += '</span>';
    if (count > 0) html += `<span class="star-rating__count">(${count})</span>`;
    html += '</span>';
    el.outerHTML = html;
  });
}

// ============================================
// KLAVIYO FEATURED REVIEWS CAROUSEL — AUTO-ROTATE
// ============================================
function initKlaviyoCarousel() {
  const container = document.getElementById('klaviyo-featured-reviews-carousel');
  if (!container) return;

  let autoTimer = null;

  function findNextBtn() {
    // Try selectors Klaviyo might use for their next/arrow button
    return container.querySelector([
      '[aria-label=”Next”]',
      '[aria-label=”next”]',
      '[class*=”next”]',
      '[class*=”Next”]',
      '[class*=”arrow--right”]',
      '[class*=”arrow-right”]'
    ].join(',')) || Array.from(container.querySelectorAll('button')).pop();
  }

  function startAutoRotate() {
    if (autoTimer) return true;
    const nextBtn = findNextBtn();
    if (!nextBtn) return false;

    autoTimer = setInterval(() => {
      if (!document.hidden) nextBtn.click();
    }, 5000);

    // Pause on hover
    container.addEventListener('mouseenter', () => clearInterval(autoTimer));
    container.addEventListener('mouseleave', () => {
      clearInterval(autoTimer);
      autoTimer = setInterval(() => {
        if (!document.hidden) nextBtn.click();
      }, 5000);
    });

    return true;
  }

  // Wait for Klaviyo to render its carousel HTML
  const obs = new MutationObserver(() => {
    if (container.querySelector('button') && startAutoRotate()) obs.disconnect();
  });
  obs.observe(container, { childList: true, subtree: true });
  [500, 1500, 3000].forEach(ms => setTimeout(startAutoRotate, ms));
}

// ============================================
// PAYPAL PAY-IN-4 MESSAGING
// ============================================
function renderPayPalMessage(containerId, placement) {
  const el = document.getElementById(containerId);
  if (!el) return;
  if (!window.PayPalSDK || !window.PayPalSDK.Messages) {
    console.warn('[PayPal] SDK not available for #' + containerId + ' — script may have failed to load or was blocked.');
    return;
  }
  const amount = parseFloat(el.dataset.ppAmount || '0');
  if (!amount) {
    el.innerHTML = '';
    return;
  }
  el.innerHTML = '';
  try {
    const promise = window.PayPalSDK.Messages({
      amount: amount,
      placement: placement || 'product',
      style: { layout: 'text', logo: { type: 'inline' } }
    }).render('#' + containerId);
    if (promise && typeof promise.catch === 'function') {
      promise.catch(err => {
        console.error('[PayPal] Message render failed for #' + containerId + ':', err);
      });
    }
  } catch (err) {
    console.error('[PayPal] Message render threw for #' + containerId + ':', err);
  }
}

// ============================================
// INIT
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  initStarRatings();
  ['PayPalMessagePDP', 'PayPalMessageCartDrawer', 'PayPalMessageCartPage'].forEach(id => {
    if (document.getElementById(id)) {
      renderPayPalMessage(id, id === 'PayPalMessagePDP' ? 'product' : 'cart');
    }
  });
  window.cartDrawer = new CartDrawer();
  new MobileMenu();
  new HeaderSearch();
  window.cartInstance = new AddToCart();
  new FilterGroups();
  new AnnouncementSlider();
  new StickyHeader();
  initLazyImages();

  document.querySelectorAll('[data-product-card]').forEach(el => new ProductCardVariants(el));
  document.querySelectorAll('.product-tabs-container').forEach(el => new ProductTabs(el));
  if (document.getElementById('StickyAtc')) new StickyAtc();
  document.querySelectorAll('.product-accordion').forEach(el => new Accordion(el));
  document.querySelectorAll('.quantity-input').forEach(el => new QuantityInput(el));

  const gallery = document.querySelector('.product-gallery');
  if (gallery) new ProductGallery();

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) new VariantSelector(productForm);
  initBackInStockForm();

  if (document.getElementById('FbtSection')) new FrequentlyBoughtTogether();
  initKlaviyoCarousel();
});
